const viewportHeight = () => window.innerHeight || document.documentElement.clientHeight;
const viewportWidth = () => window.innerWidth || document.documentElement.clientWidth;

export function fullyInViewport(element: HTMLElement) {
  // https://developer.mozilla.org/en-US/docs/Web/API/Element/getBoundingClientRect
  const bounding = element.getBoundingClientRect();
  return (
    bounding.top >= 0 &&
    bounding.left >= 0 &&
    bounding.bottom <= viewportHeight() &&
    bounding.right <= viewportWidth()
  );
}

export function closeToViewportVertically(element: HTMLElement, distance = 200) {
  // https://developer.mozilla.org/en-US/docs/Web/API/Element/getBoundingClientRect
  const bounding = element.getBoundingClientRect();
  return (
    (
      bounding.top <= viewportHeight() + distance &&
      bounding.bottom >= -distance
    )
  );
}


export function boundingToFitViewport(element: HTMLElement): ClientRect {
  // https://developer.mozilla.org/en-US/docs/Web/API/Element/getBoundingClientRect
  const bounding = element.getBoundingClientRect();
  const vH = viewportHeight();
  const vW = viewportWidth();

  const goodFit = {
    top: bounding.top,
    left: bounding.left,
    right: bounding.right,
    bottom: bounding.bottom,
    width: bounding.width,
    height: bounding.height,
  };

  if (bounding.left < 0) {
    goodFit.left = 0;
  } else if (bounding.left + bounding.width > vW) {
    goodFit.left = vW - bounding.width;
  }

  if (bounding.top < 0) {
    goodFit.top = 0;
  } else if (bounding.top + bounding.height > vH) {
    goodFit.top = vH - bounding.height;
  }

  goodFit.right = goodFit.left + goodFit.width;
  goodFit.bottom = goodFit.top + goodFit.height;

  return goodFit;
}
